/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : EMBED : EDIT : ADD : STYLES --------------- ++++++++++ */
export default theme => ({
	addanswer: {
		fontSize: pxToEm(12),
		width: 'auto',
		position: 'absolute',
		bottom: pxToEm(14),
		right: pxToEm(14),
		padding: `12px 18px`,
		zIndex: '2',
	}
});
